import React from 'react';
import MaterialTable from 'material-table';
import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};

const defaultProps = {
  data: [],
  columns: [],
};

function ProFunnelTable({
  data,
  columns,
}) {
  return (
    <MaterialTable
      title={null}
      columns={columns}
      options={{
        search: false,
        pageSize: 17
      }}
      data={data}
    />
  );
}

ProFunnelTable.propTypes = propTypes;
ProFunnelTable.defaultProps = defaultProps;
export default ProFunnelTable;



// WEBPACK FOOTER //
// ./src/components/ProFunnelTable/index.jsx